import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import * as XLSX from 'xlsx';
import { SerialData } from '../../shared/misc-classes';

@Component({
  selector: 'app-serial-data-import-dialog',
  templateUrl: './serial-data-import-dialog.html',
  styleUrls: ['./serial-data-import-dialog.css']
})
export class SerialDataImportDialog {
  Hvr: any = {};
  errorMessage: string = '';
  searchOpts:SerialDataSearchParams = new SerialDataSearchParams( '', [], []);
  // serialData: Array<SerialData> = [];
  constructor(
    public dialogRef: MatDialogRef<SerialDataImportDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  optionSelected(){
    this.searchOpts.extractedSerialDatas.length = 0;
    this.searchOpts.serialDatas.length = 0;
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

      /* grab first sheet */
      var _tmpSerials:Array<SerialData> = [];
     
      this.searchOpts.extractedSerialDatas.length = 0;
      this.searchOpts.serialDatas.length = 0;
      for(var i = 0; i < wb.SheetNames.length; i++){
        const wsname: string = wb.SheetNames[i];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];  
        const regexp = /^[0-9]*$/;
        
        var _jsonArr:Array<any> = XLSX.utils.sheet_to_json(ws, {header: 1});
        // console.log("_jsonArr",_jsonArr);
        
        for(var j = 1;j < _jsonArr.length; j++){

          var _tmpMat : string = "";
          var _tmpSerial : string= "";
          var _tmpLineIt : string= "";
          var _tmpDescp : string = "";

          if(_jsonArr[j].length > 0){
            if(_jsonArr[j][8] && typeof (_jsonArr[j][8]) === 'string' && _jsonArr[j][8] == this.data.soNo){
              if(_jsonArr[j][1] && typeof (_jsonArr[j][1]) === 'string'){
                _tmpMat = _jsonArr[j][1].trim();
              }
              if(_jsonArr[j][3] && typeof (_jsonArr[j][3]) === 'string'){
                _tmpSerial = _jsonArr[j][3].trim();
              }
              if(_jsonArr[j][9] && typeof parseInt(_jsonArr[j][9],10) === 'number'  && _jsonArr[j][9].match(regexp)){
                _tmpLineIt = _jsonArr[j][9].trim();
              }
              if(_jsonArr[j][16] && typeof (_jsonArr[j][16]) === 'string'){
                let _sotmp = _jsonArr[j][16].trim();
                let _format = "SO#"+this.data.ssoNo;
                if(_sotmp.indexOf(_format)>=0){
                  _tmpDescp = _jsonArr[j][16].trim();
                }
              }
              // if(_jsonArr[j][1] && typeof parseInt(_jsonArr[j][1],10) === 'string' && _jsonArr[j][k].match(regexp)){
              if(_tmpMat!="" && _tmpSerial!="" && _tmpLineIt!="" && _tmpDescp!=""){
                _tmpSerials.push(new SerialData(_tmpMat, _tmpSerial, _tmpLineIt, _tmpDescp));
              }
              // }
            }
            
          }
        }
      }

      this.searchOpts.extractedSerialDatas = _tmpSerials.filter((_token:SerialData) => { return _token.matNo != "" &&  _token.serialNo != "" &&  _token.itemNo != "" &&  _token.descp != ""; });
      this.searchOpts.serialDatas.push(..._tmpSerials);
      
      /* save data */
      //this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
    };
    reader.readAsBinaryString(target.files[0]);
  }


  removeIt(_lnIt){
    while(this.searchOpts.serialDatas.indexOf(_lnIt) >= 0){
      this.searchOpts.serialDatas.splice(this.searchOpts.serialDatas.indexOf(_lnIt), 1);
    }
  }

  getSDItemCountMessage():string{
    if(this.searchOpts.extractedSerialDatas.length == 0){
      return "No serial data extracted.";
    }
    else if(this.searchOpts.extractedSerialDatas.length == this.searchOpts.serialDatas.length){
      return "Showing " + this.searchOpts.extractedSerialDatas.length + " serial data extracted."
    }
    else{
      return "Selected " + this.searchOpts.serialDatas.length + " of " + this.searchOpts.extractedSerialDatas.length + " extracted.";
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  confirmClick() {
    // this.errorMessage = '';
    // if (this.data.plannedDate && this.data.actualDate) {
    //   if (this.data.actualDate > this.data.plannedDate) {
    //     if (this.data.comments == null || this.data.comments == '') {
    //       this.errorMessage = '* Please Enter Reason for Delay';
    //       return;
    //     }
    //   }
    // }
    // this.data.sDataArray.push(...this.searchOpts.extractedSerialDatas);
    this.data.sDataArray.push(...this.searchOpts.serialDatas);
    this.dialogRef.close(true);
  }
}

export class SerialDataSearchParams{
    constructor(public serialDataExtractMessage:string,
        public extractedSerialDatas:Array<SerialData>, public serialDatas:Array<SerialData>){}
}
